/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-14 09:59:22
 * @LastEditors: linxi
 * @LastEditTime: 2024-04-19 11:04:46
 */

//药品成本统计打印单
export function printDrugCostsBody(data: any) {
  const tenantName = data?.tenantName
  const timeHead = data?.timeHead
  const timeTail = data?.timeTail
  const CKLRSJData = data?.CKLRSJData
  const datas = data?.dataList || []

  const columns: any[] = [
    { title: '医生姓名', width: '18%', render: (r: any) => r?.treatmentDoctorName ?? '' },
    { title: '处方数', width: '15%', render: (r: any) => r?.recipeCount ?? '' },
    { title: '成本金额', width: '22%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalCost?.toFixed(2) ?? '')) },
    { title: '销售金额(应收)', width: '23%', render: (r: any) => r?.totalRetail?.toFixed(2) ?? '' },
    { title: '利润', width: '22%', render: (r: any) => (!CKLRSJData ? '***' : (r?.totalDiff?.toFixed(2) ?? '')) },
  ]

  const cell = (value: any, w: string, isLast: boolean) =>
    `<div style="line-height:25px;padding-left:2px;padding-right:2px;word-break:break-all;width:${w};text-align:center;box-sizing:border-box;${isLast ? '' : 'border-right:1px solid #000'}">${value}</div>`

  const headerHtml = columns
    .map((c, i) => cell(c.title, c.width, i === columns.length - 1))
    .join('')

  let rowHtml = ''
  for (const r of datas) {
    const cells = columns
      .map((c, i) => cell(c.render(r), c.width, i === columns.length - 1))
      .join('')
    rowHtml +=
      `<div style="min-height:28px;font-size:13px;display:flex;clear:left;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000">` +
      cells +
      '</div>'
  }

  const timeHeadText = (timeHead || '').toString().split(' ')[0]
  const timeTailText = (timeTail || '').toString().split(' ')[0]

  const content =
    '<div style="margin-left:10px;margin-right:10px">' +
    `<h3 style="text-align:center;margin-bottom:5px;">${tenantName}</h3>` +
    '<h3 style="text-align:center;margin-top:5px;margin-bottom:5px;">药&nbsp;&nbsp;品&nbsp;&nbsp;成&nbsp;&nbsp;本&nbsp;&nbsp;统&nbsp;&nbsp;计</h3>' +
    '<div style="font-size:14px;display:flex;text-align:left;margin-bottom:6px">' +
    `<div style="font-size:14px;width:100%;padding-left:10px;display:flex;justify-content:flex-end;">日期:<font style="font-size:14px;word-break:break-all;padding-left:10px">${timeHeadText}至${timeTailText}</font></div>` +
    '</div>' +
    `<div style="font-weight:bold;min-height:25px;line-height:25px;font-size:14px;display:flex;clear:left;border:1px solid #000">${headerHtml}</div>` +
    rowHtml +
    '</div>'

  return content
}
